import { store } from "@/store";
import router from "@/router";
import { clearTokens } from "@/utils/tokenManager";

// 로그아웃 중복 호출 방지 플래그
let isLoggingOut = false;

/**
 * 통일된 로그아웃 처리 함수
 * 화면 깜빡임과 레이아웃 문제를 해결합니다.
 */
export const handleLogout = async () => {
  // 이미 로그아웃 중이면 중복 호출 방지
  if (isLoggingOut) {
    return;
  }

  isLoggingOut = true;

  try {

    // 1. 스토어 상태 초기화 (인증 상태 해제)
    // useStorage로 인한 localStorage 업데이트가 발생할 수 있으므로 먼저 실행
    await store.dispatch("logout");

    // 2. 즉시 모든 스토리지 정리 (라우터 가드에서 세션 복원 방지)
    // 스토어 업데이트 후 실행하여 확실하게 정리
    clearAllStorage();

    // 3. 페이지 전환 효과 즉시 적용
    document.body.classList.add("page-transition", "login-transition");

    // 4. 기존 레이아웃 컴포넌트들을 즉시 숨김
    const mainLayout = document.getElementById("main-layout");
    const topMenuBar = document.querySelector(".top-menu-bar");

    if (mainLayout) {
      mainLayout.style.display = "none";
    }
    if (topMenuBar) {
      (topMenuBar as HTMLElement).style.display = "none";
    }

    window.location.href = "/login";

  } catch (error) {
    // 에러 시에도 강제 전환
    clearAllStorage();
    window.location.href = "/login";
  } finally {
    // 플래그는 페이지 이동 전까지 유지 (실제로는 페이지가 이동하므로 의미는 없지만 안전을 위해)
    // isLoggingOut = false; // 페이지 이동하므로 필요 없음
  }
};

/**
 * 스토리지 정리 함수
 */
export const clearAllStorage = () => {
  try {
    // 쿠키 및 토큰 정리
    clearTokens();

    // sessionStorage 정리
    sessionStorage.clear();

    // localStorage 정리 (로그인 관련 데이터만)
    const keysToRemove = [
      "login-session",
      "menu",
      "menuFav",
      "focusedHeaderId",
      "tabMenuId",
      "focusedTabId",
      "menuToggle",
      "selectedSite",
      "selectedSiteId",
      "selectedSiteName",
      "current_url",
      "original_url",
      "token-status",
      "accessToken",
      "refreshToken",
    ];

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });

  } catch (error) {
    console.error("❌ 스토리지 정리 중 오류:", error);
  }
};
